import { URI } from '@/config/config'

export default async (_, { headers, payload }) => {
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': headers.userToken
    },
    body: JSON.stringify(payload)
  }

  try {
    const userLoginInfoResult = await fetch(`${URI}payment/pay-parking-takeout`, opts)
    const resultJson = await userLoginInfoResult.json()

    if (userLoginInfoResult.status !== 200) {
      return Promise.reject(resultJson)
    }

    return resultJson.result
  } catch (error) {
    return Promise.reject(error)
  }
}